// extracted by mini-css-extract-plugin
module.exports = {"reference-item":"entity-lists_reference-item__PShlY"};